import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[boiDisableBodyScroll]'
})
export class DisableBodyScrollDirective {
  private interval: any;

  @HostListener('window:click', ['$event.target'])
  @HostListener('document:keydown.escape', ['$event'])
  onClick(event: KeyboardEvent | MouseEvent): void {
    if (this.interval) {
      return;
    }
    this.interval = setInterval(() => {
      if (this.isDialogOpen()) {
        document.body.style.setProperty('overflow', 'hidden');
      } else {
        document.body.style.setProperty('overflow', '');
        clearInterval(this.interval);
        this.interval = undefined;
      }
    }, 500);
  }

  private isDialogOpen(): boolean {
    return document.body.querySelectorAll('.k-overlay').length > 0;
  }
}
